<div class="dialog-content">
  <h1 mat-dialog-title>{{ title }}</h1>

  <div mat-dialog-content>
    <p>{{ message }}</p>
  </div>

  <div mat-dialog-actions class="action-buttons">
    <button mat-button mat-dialog-close (click)="onClose()">Back</button>
    <button mat-raised-button color="primary" (click)="onSubmit()">{{ confirmLabel }}</button>
  </div>
</div>
